<template>
  <div id="app" style="position: relative">
    <transition :name="transitionName">
      <keep-alive :include="includeList">
        <router-view :key="key" class="Router" />
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import { setTitle } from './utils/common';
import * as mwx from '@/utils/common.js';
import { ROUTE_NAMES } from '@/utils/routeNames.js';
import { keepAliveRouteList, getKeepAliveRouteList } from './router';

export default {
  name: 'AppMain',
  data() {
    return {
      includeList: keepAliveRouteList,
      transitionName: '',
      isFirstTime: true,
      /** addPhoto→edit 时递增，用于 router-view key，强制新 edit 实例且仍走 keep-alive 白名单 */
      editFromAddPhotoKey: 0
    };
  },
  computed: {
    key() {
      var route = this.$route;
      if (route.name == ROUTE_NAMES.edit) {
        return route.path + '\x1f' + this.editFromAddPhotoKey;
      }
      return route.path;
    }
  },
  // watch $route 决定使用哪种过渡
  watch: {
    key() {
      if (this.$route.meta.title) {
        setTitle(this.$route.meta.title);
      }
    },
    $route(to, from) {
      if (to.name == ROUTE_NAMES.edit && from.name == ROUTE_NAMES.addPhoto) {
        this.editFromAddPhotoKey += 1;
      }
      if (this.isFirstTime) {
        this.isFirstTime = false;
        return;
      }
      this.includeList = getKeepAliveRouteList({ to, from });
      let isForward = +(to.query.t || 0) > +(from.query.t || 0);
      this.transitionName = isForward ? 'slide-left' : 'slide-right';
    }
  }
};
</script>
<style scoped>
.Router {
  position: absolute;
  width: 100%;
  transition: all 0.3s ease;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}
.slide-left-enter-active,
.slide-right-leave-active {
  transition: transform 0.2s;
}

.slide-left-enter, .slide-right-leave-to /* .fade-leave-active in <2.1.8 */ {
  transform: translateX(100%);
}

.slide-left-leave, .slide-right-enter /* .fade-enter-active in <2.1.8 */ {
  transform: translateX(-100%);
}
</style>
